<div class="help-popup-button-strip flex-container align-center" >
  <button
  type="button"
  class="button clear underline"
  (click)="onOpenHelpPopup(); preventFocusOnElement($event);"
  >
    <svg class="icon icon--help-circle icon--secondary">
      <use xlink:href="#icon-help" href="#icon-help"></use>
    </svg>
    <span>{{ passwordHelp.passwordHelpReveal }}</span>
  </button>
</div>
<mono-common-help-popup
  [title]="passwordHelp.title"
  [message]="temporaryHelpHTML"
  [helpPopupPosition]="'top'"
  [open]="helpPopupOpen"
  [helpPopupCalledFrom]="helpPopupCalledFrom"
  [shadow]="false"
  (removeHelpMessage)="onCloseHelpPopup()"
  [pointer]="true"
  [elementAttachedTo]="inputAttachedTo"
></mono-common-help-popup>